import { render } from "./ArticleRewrite.vue?vue&type=template&id=5eb60411&scoped=true"
import script from "./ArticleRewrite.vue?vue&type=script&lang=js"
export * from "./ArticleRewrite.vue?vue&type=script&lang=js"

import "./ArticleRewrite.vue?vue&type=style&index=0&id=5eb60411&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb60411"]])

export default __exports__